import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import styles from './Header.module.css';
import { getOrderingMode, setOrderingMode } from '../services/apiServices'; // Importa as funções da API
import { useAuth } from '../context/AuthContext';

const Header = ({ isSoundEnabled, onToggleSound }) => {
  const [orderingMode, setLocalOrderingMode] = useState('daily'); // 'daily' ou 'pre-order'
  const { logout } = useAuth();
  const navigate = useNavigate();

  // Busca o modo de pedido inicial quando o compnente é montado
  useEffect(() => {
    const fetchMode = async () => {
      try {
        const modeData = await getOrderingMode();
        setLocalOrderingMode(modeData.mode);
      } catch (error) {
        console.error("Erro ao buscar modo de pedido no Header:", error);
      }
    };
    fetchMode();
  }, []);

  const handleToggleOrderingMode = async () => {
    const newMode = orderingMode === 'daily' ? 'pre-order' : 'daily';
    try {
      await setOrderingMode(newMode); // Chama a função de API
      setLocalOrderingMode(newMode); // Atualiza o estado local
    } catch (error) {
      console.error("Erro ao alterar o modo de pedido:", error);
      alert("Falha ao alterar o modo de pedido.");
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className={styles.header}>
      <div className={styles.logo}>
        <h1>Casa de Carnes Bom Jesus</h1>
      </div>
      <nav className={styles.nav}>
        <NavLink to="/dashboard" className={({ isActive }) => (isActive ? styles.activeLink : styles.link)}>Painel de Atendimento</NavLink>
        <NavLink to="/clientes" className={({ isActive }) => (isActive ? styles.activeLink : styles.link)}>Clientes</NavLink>
        <NavLink to="/stock" className={({ isActive }) => (isActive ? styles.activeLink : styles.link)}>Estoque</NavLink>
        <NavLink to="/relatorios" className={({ isActive }) => (isActive ? styles.activeLink : styles.link)}>Relatórios</NavLink>
        {/* Toggle Switch de Modo de Pedido */}
        <div className={styles.toggleContainer} onClick={handleToggleOrderingMode} title={orderingMode === 'daily' ? 'Mudar para Encomendas' : 'Mudar para Vendas do Dia'}>
          <span className={`${styles.toggleLabel} ${orderingMode === 'daily' ? styles.activeLabel : ''}`}>Dia</span>
          <div className={`${styles.toggleSwitch} ${styles[orderingMode]}`}>
            <div className={styles.toggleSlider}></div>
          </div>
          <span className={`${styles.toggleLabel} ${orderingMode === 'pre-order' ? styles.activeLabel : ''}`}>Encomenda</span>
        </div>
      </nav>
      <div className={styles.soundToggle}>
        <button onClick={onToggleSound} className={styles.soundButton} title={isSoundEnabled ? 'Desativar som' : 'Ativar som'}>
          {isSoundEnabled ? '🔔' : '🔕'}
        </button>
        <button onClick={handleLogout} className={styles.soundButton} style={{ marginLeft: '10px', fontSize: '1rem', fontWeight: 'bold' }} title="Sair">
          Sair
        </button>
      </div>
    </header>
  );
};

export default Header;